module.exports = __webpack_public_path__ + "static/matt-42dfe6b1cbf08787167f7ce44a8c9769.jpeg";